// Why a customer can't be auctioned for yet (reason codes from /auction-readiness).
// Shared by the profile header and the "เก็บเงิน" confirm box.
export const AUCTION_NOT_READY_TEXT = {
  not_platform: "ไม่ใช่ลูกค้าแพลตฟอร์ม · กด 'เชื่อมเข้าแพลตฟอร์ม'",
  no_wallet: 'ไม่มี Wallet',
  line_not_connected: 'ยังไม่เชื่อม LINE กับบัญชี',
  line_blocked: 'LINE บล็อก',
  line_not_friend: 'ยังไม่เพิ่มเพื่อน LINE',
};
